import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import AboutMain from "../images/about/about-main.jpg";
import Atvbanner from "../components/atvbanner";
import Atvbanner2 from "../components/atvbanner2";
import PickCar from "../components/PickCar";
import PickCeleb from "../components/PickCeleb";



import { Helmet } from "react-helmet";
import Dronebanner from "../components/dronebanner";

function ATV() {
  return (
    <>
      <Helmet>
        <title>ATV Tours - Price Is Right ATV</title>
        <meta
          name="description"
          content="Capture stunning moments with professional drone photo and video shoots by Price Is Right ATV in Leeward Palms, Turks & Caicos Islands. Book now for breathtaking aerial views and unforgettable memories!"
        />
        {/* Add more meta tags as needed */}
      </Helmet>

      <section className="about-page" style={{ position: 'relative', zIndex: 400 }}>
        <HeroPages name="ATV Tours Booking" />


<PickCar />
      <PickCeleb/>

 
       
        
        <div >
          <Atvbanner2/>
      <Atvbanner/>
        </div>

        
      </section>

   

      <div className="book-banner" style={{ marginTop: '-60px', position: 'relative', zIndex: 10 }}>
        <div className="book-banner__overlay"></div>
        <div className="container">
          <div className="text-content">
            <h2>For more information, we can be contacted at</h2>
            <span>
              <i className="fa-solid fa-phone"></i>
              <h3 style={{ color: 'gold' }}> +1649 3413819</h3> 
            </span>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default ATV;
